import { useEffect, useRef, useState } from 'react';

/** Recouvre le hero : marge négative = hauteur réelle du menu (overlay transparent). */
export function useOverlayMenuPull(enabled) {
  const ref = useRef(null);
  const [pullPx, setPullPx] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setPullPx(0);
      return undefined;
    }
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      setPullPx(el.offsetHeight || 0);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener('resize', measure);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [enabled]);

  return {
    ref,
    marginBottom: enabled && pullPx > 0 ? -pullPx : undefined,
  };
}
